export const levels = {
  gym: {
    de: "Arena",
    es: "Gimnasio",
    en: "Gym",
    ja: "ジム",
    fr: "Gym",
    zh: "Gym",
  },
  pokeball: {
    de: "Pokéball",
    es: "Pokéball",
    en: "Pokéball",
    ja: "モンスターボール",
    fr: "Pokéball",
    zh: "Pokéball",
  },
  greatball: {
    de: "Superball",
    es: "Super Ball",
    en: "Great Ball",
    ja: "スーパーボール",
    fr: "Super Ball",
    zh: "Great Ball",
  },
  ultraball: {
    de: "HyperBall",
    es: "Ultra Ball",
    en: "Ultra Ball",
    ja: "ハイパーボール",
    fr: "Hyper Ball",
    zh: "Ultra Ball",
  },
  razzberry: {
    de: "Himmihbeere",
    es: "Razz Berry",
    en: "Razz Berry",
    ja: "ズリのみ",
    fr: "Baie Framby",
    zh: "Razz Berry",
  },
  potion: {
    de: "Trank",
    es: "Poción",
    en: "Potion",
    ja: "キズぐすり",
    fr: "Potion",
    zh: "Potion",
  },
  superpotion: {
    de: "Supertrank",
    es: "Superpoción",
    en: "Super Potion",
    ja: "いいキズぐすり",
    fr: "Super Potion",
    zh: "Super Potion",
  },
  hyperpotion: {
    de: "Hypertrank",
    es: "Hiperpoción",
    en: "Hyper Potion",
    ja: "すごいキズぐすり",
    fr: "Hyper Potion",
    zh: "Hyper Potion",
  },
  maxpotion: {
    de: "Maxtrank",
    es: "Maxpoción",
    en: "Max Potion",
    ja: "まんたんのくすり",
    fr: "Max Potion",
    zh: "Max Potion",
  },
  revive: {
    de: "Beleber",
    es: "Revivir",
    en: "Revive",
    ja: "げんぎのかけら",
    fr: "Revivre",
    zh: "Revive",
  },
  maxrevive: {
    de: "Maxbeleber",
    es: "Max Revivir",
    en: "Max Revive",
    ja: "げんきのかたまり",
    fr: "Max Revivre",
    zh: "Max Revive",
  },
  incense: {
    de: "Rauch",
    es: "Incienso",
    en: "Incense",
    ja: "おこう",
    fr: "Encens",
    zh: "Incense",
  },
  luremodule: {
    de: "Lockmodul",
    es: "Módulo Cebo",
    en: "Lure Module",
    ja: "ルアーモジュール",
    fr: "Module Leurre",
    zh: "Lure Module",
  },
  incubator: { // unlimited
    de: "Ei-Brutmaschine",
    es: "Incubadora",
    en: "Incubator",
    ja: "ムゲンふかそうち",
    fr: "Incubateur",
    zh: "Incubator",
  },
  eggincubator: { // limited uses
    de: "Ei-Brutmaschine",
    es: "Egg Incubadora",
    en: "Egg Incubator",
    ja: "ふかそうち",
    fr: "Egg Incubateur",
    zh: "Egg Incubator",
  },
  luckyegg: { 
    de: "Glücks-ei",
    es: "Huevo Suerte",
    en: "Lucky Egg",
    ja: "しあわせタマゴ",
    fr: "Oeuf Chance",
    zh: "Lucky Egg",
  },
}